import { ControlBase } from './control-base';

export class MetadataNumberbox extends ControlBase<string> {
    override controlType = 'number';
}
